module.exports = "<div *ngIf=\"isCountWidget()\">\r\n  <count-widget [(model)]=\"model\" [showSelect]=\"showSelect\"></count-widget>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/widget/widget.component.html
// module id = ./src/app/components/account/widget/widget.component.html
// module chunks = main